// import {AuthUserEffects} from "./entities/uaa/auth-user.effects";
import {RegionEffects} from "./entities/system-configurations/administrative-area/region/region.effects";
import {DistrictEffects} from "./entities/system-configurations/administrative-area/district/district.effects";
import {WardEffects} from "./entities/system-configurations/administrative-area/ward/ward.effects";

import {StreetEffects} from "./entities/system-configurations/administrative-area/street/street.effects";
import {StoreItemEffects} from "./entities/store-item/store-item.effects";


export const effects = [
  // AuthUserEffects,
  RegionEffects,
  DistrictEffects,
  WardEffects,
  StreetEffects,
  StoreItemEffects
];
